(function () {
  'use strict';

  function getHeaderHeight() {
    var header = document.querySelector('.js-header');
    return header ? Math.round(header.getBoundingClientRect().height) : 0;
  }

  function updateScrollMargins(collections) {
    var offset = getHeaderHeight() + 8;
    collections.forEach(function (col) {
      col.style.scrollMarginTop = offset + 'px';
    });
  }

  /* ── Bullet pagination (same design as featured-products) ──────────── */
  function initPagination(grid) {
    var paginationEl = grid.nextElementSibling;
    if (!paginationEl || !paginationEl.classList.contains('mlrs-cp__pagination')) return;

    var items = Array.prototype.slice.call(grid.children);
    if (!items.length) return;

    items.forEach(function (item, i) {
      var btn = document.createElement('button');
      btn.className = 'swiper-pagination-bullet';
      btn.type = 'button';
      btn.setAttribute('aria-label', String(i + 1));
      btn.addEventListener('click', function () {
        var targetLeft = item.getBoundingClientRect().left
          - grid.getBoundingClientRect().left
          + grid.scrollLeft;
        grid.scrollTo({ left: targetLeft, behavior: 'smooth' });
      });
      paginationEl.appendChild(btn);
    });

    var bullets = Array.prototype.slice.call(
      paginationEl.querySelectorAll('.swiper-pagination-bullet')
    );

    function update() {
      var maxScroll = grid.scrollWidth - grid.clientWidth;
      if (maxScroll < 2) {
        paginationEl.classList.add('swiper-pagination-lock');
        return;
      }
      paginationEl.classList.remove('swiper-pagination-lock');
      var gridLeft = grid.getBoundingClientRect().left;
      var activeIndex = 0;
      var minDist = Infinity;
      items.forEach(function (item, i) {
        var dist = Math.abs(item.getBoundingClientRect().left - gridLeft);
        if (dist < minDist) { minDist = dist; activeIndex = i; }
      });
      bullets.forEach(function (b, i) {
        b.classList.toggle('swiper-pagination-bullet-active', i === activeIndex);
      });
    }

    grid.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    setTimeout(update, 120);
  }

  /* ── Collections page ───────────────────────────────────────────────── */
  function initCollectionsPage() {
    var sections = document.querySelectorAll('.mlrs-cp');
    if (!sections.length) return;

    sections.forEach(function (section) {
      var pills = Array.prototype.slice.call(section.querySelectorAll('.js-mlrs-cp-pill'));
      var collections = Array.prototype.slice.call(section.querySelectorAll('.mlrs-cp__collection'));
      var grids = Array.prototype.slice.call(section.querySelectorAll('.mlrs-cp__grid'));

      grids.forEach(initPagination);
      if (!pills.length || !collections.length) return;

      updateScrollMargins(collections);
      window.addEventListener('resize', function () {
        updateScrollMargins(collections);
      }, { passive: true });

      /*
       * Index-based match: pills[i] ↔ collections[i]
       * Both come from the same {% for block in section.blocks %} loop,
       * filtered by block.type == 'collection', so order is guaranteed.
       * No ID comparison needed — avoids any block.id character issues.
       */
      function setActiveByIndex(idx) {
        pills.forEach(function (pill, i) {
          pill.classList.toggle('is-active', i === idx);
        });
      }

      /* Scroll lock: prevents scroll listener from overriding a click */
      var scrollLocked = false;
      var scrollLockTimer = null;

      /* ── Click handler ──────────────────────────────────────────────── */
      pills.forEach(function (pill, idx) {
        pill.addEventListener('click', function (e) {
          e.preventDefault();
          var col = collections[idx];
          if (!col) return;

          /* 1. Immediate visual feedback */
          setActiveByIndex(idx);

          /* 2. Lock scroll listener for smooth-scroll duration */
          scrollLocked = true;
          clearTimeout(scrollLockTimer);
          scrollLockTimer = setTimeout(function () {
            scrollLocked = false;
            syncActive();
          }, 900);

          /* 3. Smooth scroll to collection */
          var top = col.getBoundingClientRect().top + window.pageYOffset - getHeaderHeight() - 8;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
      });

      /* ── Scroll detection: IntersectionObserver (primary) ───────────── */
      /* rootMargin shrinks the "active zone" to the area just below the  */
      /* header (top) and keeps the bottom 55% of viewport excluded.      */
      /* A collection becomes active as soon as it enters this zone.      */
      var ioSupported = typeof IntersectionObserver !== 'undefined';

      if (ioSupported) {
        var headerH = getHeaderHeight();
        var topMargin = -(headerH + 10);   /* px below header before triggering */
        var bottomMargin = '-55%';          /* ignore bottom 55% of viewport     */

        var observer = new IntersectionObserver(function (entries) {
          if (scrollLocked) return;
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var idx = collections.indexOf(entry.target);
            if (idx !== -1) setActiveByIndex(idx);
          });
        }, {
          rootMargin: topMargin + 'px 0px ' + bottomMargin + ' 0px',
          threshold: 0
        });

        collections.forEach(function (col) { observer.observe(col); });
      }

      /* ── Scroll detection: getBoundingClientRect fallback ───────────── */
      /* Also runs at init and on resize to ensure correct initial state.  */
      function syncActive() {
        if (scrollLocked) return;
        /* Trigger line: header bottom + 30% of viewport height */
        var triggerLine = getHeaderHeight() + Math.round(window.innerHeight * 0.3);
        var activeIdx = 0;
        collections.forEach(function (col, i) {
          /* Last collection whose top has crossed the trigger line wins */
          if (col.getBoundingClientRect().top <= triggerLine) activeIdx = i;
        });
        setActiveByIndex(activeIdx);
      }

      window.addEventListener('scroll', syncActive, { passive: true });
      window.addEventListener('resize', syncActive, { passive: true });

      /* Set initial active state once DOM is laid out */
      syncActive();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionsPage);
  } else {
    initCollectionsPage();
  }
})();
